import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { AppService } from "src/app/services/services";
import { Subject, Observable } from 'rxjs';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { Modal } from 'bootstrap';
import { NgxUiLoaderService } from "ngx-ui-loader";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { EncryptionService } from "src/app/services/encryption.service";
import { ErrorModalComponent } from "src/app/common/error-modal/error-modal.component";

@Component({
  selector: 'nri-app-photo',
  templateUrl: './photo.component.html',
  styleUrls: ['./photo.component.scss']
})

export class PhotoComponent implements OnInit {
  rmModule: boolean = false;
  selfieSupportError: boolean = false;
  takeSelfie: boolean = false;
  public showWebcam = true;
  public allowCameraSwitch = true;
  public multipleWebcamsAvailable = false;
  public deviceId: string;
  public videoOptions: MediaTrackConstraints = {
    // width: {ideal: 1024},
    // height: {ideal: 576}
  };
  public errors: WebcamInitError[] = [];

  // latest snapshot
  public webcamImage: WebcamImage;

  // webcam snapshot trigger
  private trigger: Subject<void> = new Subject<void>();
  // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
  private nextWebcam: Subject<boolean | string> = new Subject<boolean | string>();
  erefNo: any;
  latitude: any;
  longitude: any;
  locationError: boolean;
  cameraDisabled: boolean;
  selfieImage: string;
  retake: boolean;
  myModal: any;
  showImageError: boolean = false;
  isMobile: boolean = false;
  isRmUser: boolean = false;
  public capture: boolean = false;
  geoerror: string = '';
  anothercountry: any;
  rotationAngle: number = 0;
  rotatedImage: string = '';
  @Output() photoCheck = new EventEmitter<boolean>();
  @ViewChild('errorComp') errorComp: ErrorModalComponent;
  constructor(private _http: AppService, private loader: NgxUiLoaderService, private toastr: ToastrService, private router: Router, private http: EncryptionService) {
    // this._http.getStatus().subscribe(data=>{
    //     if(data.RMModule){
    //         this.rmModule = true;
    //       }else{
    //         this.rmModule = false;
    //       }
    // });
    this._http.getRefNum().subscribe(data => {
      this.erefNo = data;
    });
  }

  ngOnInit() {
    if ('mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices) {
      this.selfieSupportError = false;
    } else {
      this.selfieSupportError = true
    }
    if (/Android|webOS|iPhone|iPad|iPod|pocket|psp|kindle|avantgo|blazer|midori|Tablet|Palm|maemo|plucker|phone|BlackBerry|symbian|IEMobile|mobile|ZuneWP7|Windows Phone|Opera Mini/i.test(navigator.userAgent)) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }

    WebcamUtil.getAvailableVideoInputs().then((mediaDevices: MediaDeviceInfo[]) => {
      this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
    });

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((values) => {
        this.latitude = values?.coords?.latitude
        this.longitude = values?.coords?.longitude;
      });
    }

    navigator.mediaDevices.getUserMedia({
      video: true,
      audio: false
    }).then(stream => {
      this.cameraDisabled = false;
    }).catch(err => {
      this.cameraDisabled = true;
    });
    if (this.erefNo) {
      this.getImages();
    }
  }




  public triggerSnapshot(): void {
    this.trigger.next();
    this.capture = true;
  }

  public toggleWebcam(): void {
    this.showWebcam = !this.showWebcam;
  }

  public handleInitError(error: WebcamInitError): void {
    this.errors.push(error);
  }

  public showNextWebcam(directionOrDeviceId: boolean | string): void {
    this.nextWebcam.next(directionOrDeviceId);
  }

  public handleImage(webcamImage: WebcamImage): void {
    this.rotationAngle = 0;
    this.webcamImage = webcamImage;
    this.retake = false;
  }

  public cameraWasSwitched(deviceId: string): void {
    this.deviceId = deviceId;
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public get nextWebcamObservable(): Observable<boolean | string> {
    return this.nextWebcam.asObservable();
  }

  upldImg() {
    this.capture = false;
     // ✅ Always use the rotated image if available
  const img = this.rotatedImage || this.webcamImage?.imageAsDataUrl;
  if (!img) {
    this.errorComp.ModalShow('No image found. Please capture your photo.');
    return;
  }
    let url = 'DIY/FacePhotoLiveness';
    let params = {
      "ReferenceNumber": this.erefNo,
      "Image": img,
      "ImageName": "Photo",
      "Latitude": this.latitude,
      "Longitude": this.longitude
    }
    this.loader.start();

    let checkSum = this.erefNo + this.latitude + this.longitude;

    this._http.httpPost(url, params, checkSum).subscribe({
      next: (data: any) => {
        let photoLiveValue = this.http.decryptUsingAES256(data.OutPut)
        if (photoLiveValue && photoLiveValue.IsSuccess) {
          this.loader.stop();
          this.selfieImage = this.webcamImage.imageAsDataUrl;
          this.takeSelfie = false;
          this.imgUpld(this.selfieImage);
        } else {
          this.rotatedImage =''
          this.photoCheck.emit(false);
          this.loader.stop();
          if (photoLiveValue.FailureMessage && photoLiveValue.error === '101') {
            const element = document.getElementById('anothercountry') as HTMLElement;
            this.anothercountry = new Modal(element, { backdrop: 'static', keyboard: false });
            this.anothercountry.show();
            this.geoerror = photoLiveValue.FailureMessage;
          }
          else if (photoLiveValue.FailureMessage) {
            // this.toastr.error(photoLiveValue.ErrorMessage)
            this.errorComp.ModalShow(photoLiveValue.FailureMessage);
          } else {
            // this.toastr.error('Please retake selfie image')
            this.errorComp.ModalShow('Please retake selfie image');
          }
        }
      }
    })

  }

  imgModal() {
    const element = document.getElementById('myModal') as HTMLElement;
    this.myModal = new Modal(element, { backdrop: 'static', keyboard: false });
    this.myModal.show();
  }

  captureSelfie() {
    this.takeSelfie = true;
    this.retake = true;
    this.selfieImage = "";
    this.rotatedImage =''
  }

  upldPhoto(event: any) {
    const getImg = event.srcElement !== undefined ? event.srcElement.value.substr(event.srcElement.value.indexOf('.')) : '';
    if ((getImg.toLowerCase() !== '.jpeg' && getImg.toLowerCase() !== '.jpg' && getImg.toLowerCase() !== '.png')) {
      this.showImageError = true;
      return;
    } else {
      this.showImageError = false;
    }

    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = () => {
        let img = reader.result;
        let byteArray = this.convertDataURIToBinary(reader.result);
        this.imgUpld(img);
      }
    }
  }

  convertDataURIToBinary(dataURI: any) {
    var base64Index = dataURI.indexOf(';base64,') + ';base64,'.length;
    var base64 = dataURI.substring(base64Index);
    var raw = window.atob(base64);
    var rawLength = raw.length;
    var array = new Uint8Array(new ArrayBuffer(rawLength));

    for (let i = 0; i < rawLength; i++) {
      array[i] = raw.charCodeAt(i);
    }
    return array;
  }

  imgUpld(img: any) {
    console.log(img);
    const checkSum = 'Photo' + this.erefNo;
    const params = {
      "ImageName": 'Photo',
      "ReferenceNumber": this.erefNo,
      "DocumentType": '',
      "Image": img,
      "Extention": 'jpeg'
    }
    const path = 'DIY/DIYImageUpload';
    this.loader.start();
    this._http.httpPost(path, params, checkSum).subscribe({
      next: (data: any) => {
        this.loader.stop();
        let imageUpld = this.http.decryptUsingAES256(data.OutPut)
        if (imageUpld.IsSuccess) {
          // this.toastr.success("File updated successfully.");
          // this.errorComp.ModalShow('File updated successfully.');
          this.selfieImage = img;
          this.photoCheck.emit(true);
        } else {
          this.photoCheck.emit(false);
          // this.toastr.error("File upload failed. Please try again later.");
          this.errorComp.ModalShow('File upload failed. Please try again later.');
        }
      },
      error: e => {
        this.loader.stop();
        if (!window.navigator.onLine) {
          // this.toastr.error("It appears that your internet connectivity is slow or please try again.")
          this.errorComp.ModalShow('It appears that your internet connectivity is slow or please try again.');
        } else {
          // this.toastr.error(e.error.Message)
          this.errorComp.ModalShow(e.error.Message);
        }
      }
    });
  }

  getImages() {
    const checkSum = 'Photo' + this.erefNo;
    const url = 'DIY/GetImagesByName';

    const params = {
      'ReferenceNumber': this.erefNo,
      'ImageName': 'Photo'
    }
    this.loader.start();
    this._http.httpPost(url, params, checkSum).subscribe({
      next: (data: any) => {
        let getImageVal = this.http.decryptUsingAES256(data.OutPut)
        this.loader.stop();
        if (getImageVal && getImageVal.IsSuccess) {
          if (getImageVal.Images[0].Image) {
            this.selfieImage = 'data:image/jpeg;base64,' + getImageVal.Images[0].Image;
            this.photoCheck.emit(true);
          }
        }
      },
      error: e => {
        this.loader.stop();
        if (!window.navigator.onLine) {
          // this.toastr.error("It appears that your internet connectivity is slow or please try again.")
          this.errorComp.ModalShow("It appears that your internet connectivity is slow or please try again.");
        } else {
          // this.toastr.error(e.error.Message)
          this.errorComp.ModalShow(e.error.Message);
        }
      }
    });
  }

  stageValidate() {
    if (this.selfieImage) {
      this.router.navigate(['/passport']);
    }
  }
  backStage() {
    this.router.navigate(['/pan'])
  }
  homepage() {
    sessionStorage.clear();
    this.router.navigate(['/register'], { replaceUrl: true });
    location.reload();
  }
  //  rotateImage() {
  //   this.rotationAngle = (this.rotationAngle + 90) % 360; // Rotate 90° each click
  // }
rotateImage(direction: 'left' | 'right') {
  // pick the source image — either the rotated one or the captured one
  const src = this.rotatedImage || this.webcamImage?.imageAsDataUrl;
  if (!src) return;

  const img = new Image();
  img.src = src;
  img.onload = () => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d')!;
    const size = 300;

    canvas.width = size;
    canvas.height = size;

    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, size, size);

    // adjust rotation angle
    this.rotationAngle =
      direction === 'right'
        ? (this.rotationAngle + 90) % 360
        : (this.rotationAngle - 90 + 360) % 360;

    // rotate around center
    ctx.translate(size / 2, size / 2);
    ctx.rotate((this.rotationAngle * Math.PI) / 180);

    // optional: mirror to match preview
    ctx.scale(-1, 1);

    // scale to fit canvas
    const scale = Math.min(size / img.width, size / img.height);
    const drawW = img.width * scale;
    const drawH = img.height * scale;

    ctx.drawImage(img, -drawW / 2, -drawH / 2, drawW, drawH);

    // save rotated image to variable
    this.rotatedImage = canvas.toDataURL('image/jpeg');

    // ✅ also update preview immediately
    this.webcamImage = { ...this.webcamImage, imageAsDataUrl: this.rotatedImage } as any;
  };
}




}